Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports['default'] = validatePropTypes;
// Returns list of PropTypes validation error stack trace strings
function validatePropTypes(propTypes, props) {
  return Object.entries(propTypes).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        propName = _ref2[0],
        validationFunc = _ref2[1];

    return (
      // The extra fields make the error message nicer, e.g.
      // Error: Required prop `${propName}` was not specified in validatePropTypes.
      validationFunc(props, propName, 'validatePropTypes', 'prop', undefined,
      // https://github.com/facebook/react/blob/master/src/isomorphic/classic/types/ReactPropTypes.js#L133
      'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED' // _FROM_FB
      )
    );
  }).filter(function (errorString) {
    return errorString != null;
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/jitney/validatePropTypes.js
// module id = 477
// module chunks = 168707334958949